import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const RootLayout = (props: Props) => {
  const { children } = props;

  return (
    <html lang="de">
      <head>
        <link rel="manifest" href="/g/site.webmanifest" />
        <link rel="mask-icon" href="/g/safari-pinned-tab.svg" color="#c02169" />

        <meta property="og:title" content="Verschenke ein Lächeln - zmyle" />
        <meta property="og:site_name" content="zmyle" />
        <meta property="og:site_name" content="zmyle" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@zmyle_de" />
        <meta name="twitter:title" content="Verschenke ein Lächeln - zmyle" />
        <meta
          name="twitter:description"
          content="Verschenke Gutscheine von lokalen Unternehmen oder Stadtgutscheine von Städten und ganzen Regionen - einfach per WhatsApp &amp; Co."
        />

        <meta
          name="description"
          content="Verschenke Gutscheine von lokalen Unternehmen oder Stadtgutscheine von Städten und ganzen Regionen - einfach per WhatsApp &amp; Co."
        />
        <meta name="application-name" content="zmyle" />
        <meta name="author" content="zmyle GmbH" />
        <meta
          name="copyright"
          content="all rights reserved; zmyle and the zmyle logo is a registered trademark of zmyle GmbH"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Pragma" content="no-cache" />
        <meta httpEquiv="Expires" content="0" />
        <meta name="robots" content="noindex,nofollow" />
        <meta name="theme-color" content="#e9eef2" />
        <meta name="msapplication-TileColor" content="#e9eef2" />

        <link rel="preconnect" href="https://fonts.bunny.net" />
        <link
          href="https://fonts.bunny.net/css?family=roboto:100,300,300i,400,400i,500,500i,700,700i,900,900i|roboto-slab:100,200,300,400,500,600,700,900,900i|source-code-pro:200,200i,300,300i,400,400i,500,500i,600,600i,700,700i"
          rel="stylesheet"
        />
      </head>

      <body>{children}</body>
    </html>
  );
};

export default RootLayout;
